import { parseISO, isToday, isYesterday, format } from "date-fns";

import { NavigateFunction } from "react-router-dom";
import { currencyTypes } from "../types";
import { UserType } from "../utils-func/enums";

function getRandomColors(index: number) {
  const colors = ["#1F3A93", "#009688", "#1976D2", "#E65100", "#C62828"];
  return colors[index % colors.length];
}

const formatDate = (dateString: string) => {
  const date = parseISO(dateString);
  if (isToday(date)) return "Today";
  if (isYesterday(date)) return "Yesterday";
  return format(date, "EEE MMM d, yyyy"); // Example: Tue Feb 18 2025
};

function formatTimestamp(timestamp: string) {
  const date = new Date(timestamp);
  const now = new Date();
  const yesterday = new Date(now.getTime() - 86400000); // 86400000 = 24 hours in milliseconds

  if (date.toLocaleDateString() === now.toLocaleDateString()) {
    return "Today";
  } else if (date.toLocaleDateString() === yesterday.toLocaleDateString()) {
    return "Yesterday";
  } else {
    return date.toLocaleString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  }
}

function formatTimeElapsed(date: string): string {
  const now = new Date();
  const createdDate = new Date(date);

  const diffInSeconds = Math.floor(
    (now.getTime() - createdDate.getTime()) / 1000,
  );

  if (diffInSeconds < 60) {
    return diffInSeconds <= 1 ? "1 second ago" : `${diffInSeconds} seconds ago`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return diffInMinutes === 1 ? "1 min ago" : `${diffInMinutes} mins ago`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return diffInHours === 1 ? "1 hour ago" : `${diffInHours} hours ago`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return diffInDays === 1 ? "1 day ago" : `${diffInDays} days ago`;
  }

  const diffInWeeks = Math.floor(diffInDays / 7);
  if (diffInWeeks < 4) {
    return diffInWeeks === 1 ? "1 week ago" : `${diffInWeeks} weeks ago`;
  }

  // ✅ Better month calculation
  const yearsDiff = now.getFullYear() - createdDate.getFullYear();
  const monthsDiff = yearsDiff * 12 + (now.getMonth() - createdDate.getMonth());

  if (monthsDiff < 12) {
    return monthsDiff <= 1 ? "1 month ago" : `${monthsDiff} months ago`;
  }

  const diffInYears = Math.floor(monthsDiff / 12);
  return diffInYears === 1 ? "1 year ago" : `${diffInYears} years ago`;
}

const handleNavigate = (
  role: string | undefined,
  navigate: NavigateFunction,
) => {
  switch (role) {
    case UserType.INDIVIDUAL: {
      navigate("/individual");

      break;
    }

    case UserType.ADMIN: {
      navigate("/admin");
      break;
    }

    case UserType.COMPANY: {
      navigate("/individual");
      break;
    }
    case UserType.COURT_STAFF: {
      navigate("/court-staff");
      break;
    }

    default:
      {
      }
      break;
  }
};

const formatCurrency = (currencyType: currencyTypes) => {
  return new Intl.NumberFormat(currencyType.iso, {
    style: "currency",
    currency: currencyType.slug,
  });
};

export {
  getRandomColors,
  formatDate,
  formatTimestamp,
  formatTimeElapsed,
  handleNavigate,
  formatCurrency,
};
